export const parseCSV = (text) => {
  const lines = text.split("\n").filter((line) => line.trim());
  if (lines.length === 0) return { headers: [], rows: [] };

  // Strip surrounding double-quotes that serializePreviewToCSV wraps headers with
  const headers = lines[0].split(",").map((h) => h.trim().replace(/^"|"$/g, ""));
  const rows = [];

  for (let i = 1; i < lines.length; i++) {
    const line = lines[i];
    const cells = [];
    let current = "";
    let insideQuotes = false;

    for (let j = 0; j < line.length; j++) {
      const char = line[j];
      if (char === '"') {
        insideQuotes = !insideQuotes;
      } else if (char === "," && !insideQuotes) {
        cells.push(current.trim());
        current = "";
      } else {
        current += char;
      }
    }
    cells.push(current.trim());

    const row = {};
    headers.forEach((header, idx) => {
      row[header] = cells[idx] || "";
    });
    rows.push(row);
  }

  return { headers, rows };
};

export const serializePreviewToCSV = (rows) => {
  if (rows.length === 0) return "";

  const headers = Object.keys(rows[0]);
  // Do NOT quote headers — keeps round-trip parsing clean
  const headerLine = headers.join(",");

  const dataLines = rows.map((row) => {
    return headers
      .map((header) => {
        const value = row[header] || "";
        const strValue = String(value);
        if (
          strValue.includes(",") ||
          strValue.includes('"') ||
          strValue.includes("\n")
        ) {
          return `"${strValue.replace(/"/g, '""')}"`;
        }
        return strValue;
      })
      .join(",");
  });

  return [headerLine, ...dataLines].join("\n");
};